import * as React from "react";
import styled, { css } from "../../../styled/index";
import { Modal } from "../../layout/modal";
import { ModalContent, RotateLoader, shadeAlternate } from "../../..";
const SelectWrapper = styled("div") `
  height: 100%;
  max-height: 300px;
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 10px;
  }
  ::-webkit-scrollbar-track {
    background: ${({ theme }) => shadeAlternate(0.25, theme.colors.background)};
  }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => shadeAlternate(0.45, theme.colors.background)};
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => shadeAlternate(0.5, theme.colors.background)};
  }
`;
const SelectItem = styled("div") `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 15px;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => shadeAlternate(0.1, theme.colors.background)};
  &:hover {
    background: ${({ theme }) => shadeAlternate(0.05, theme.colors.background)};
  }
  ${({ disabled, theme }) => !disabled
    ? ""
    : css `
          cursor: not-allowed;
          background: ${shadeAlternate(0.1, theme.colors.background)};
        `}
`;
export class SelectModal extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            asyncOptions: [],
            asyncLoading: true,
            asyncError: false,
        };
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.active && this.props.active) {
            if (this.props.getOptions) {
                this.getOptions();
            }
            setTimeout(() => {
                const el = document.getElementById(this.props.innerId);
                if (el) {
                    el.scrollTop = 0;
                }
            }, 50);
        }
    }
    async getOptions() {
        if (!this.props.getOptions)
            return;
        this.setState({
            asyncOptions: [],
            asyncLoading: true,
            asyncError: false,
        });
        try {
            const options = await this.props.getOptions();
            this.setState({
                asyncOptions: options,
                asyncLoading: false,
                asyncError: false,
            });
        }
        catch (e) {
            this.setState({
                asyncOptions: [],
                asyncLoading: false,
                asyncError: true,
            });
        }
    }
    get isAsync() {
        return !!this.props.getOptions;
    }
    renderOptions() {
        const options = this.isAsync ? this.state.asyncOptions : this.props.options;
        return options.map((o, i) => {
            return (React.createElement(SelectItem, { key: i, disabled: o.disabled, onClick: () => {
                    if (!o.disabled)
                        this.props.onSelect(o);
                } },
                React.createElement("div", null, o.label),
                o.sublabel && React.createElement("div", { className: "text-sm font-semibold mt-1" }, o.sublabel)));
        });
    }
    renderAsync() {
        const { asyncLoading, asyncError } = this.state;
        if (asyncLoading) {
            return (React.createElement("div", { className: "flex items-center justify-center p-6" },
                React.createElement(RotateLoader, { size: 2 })));
        }
        if (asyncError) {
            return (React.createElement("div", { className: "flex items-center justify-center p-6" },
                React.createElement("p", null,
                    "An error occurred, ",
                    React.createElement("a", { onClick: () => this.getOptions() }, "refresh"))));
        }
        return this.renderOptions();
    }
    render() {
        const { innerId, title, children } = this.props;
        const { isAsync } = this;
        return (React.createElement(Modal, { closeButton: true, ...this.props },
            React.createElement(ModalContent, { className: "text-center" },
                React.createElement("p", { className: "text-lg font-medium" }, title)),
            React.createElement(ModalContent, { paddinglr: 0, paddingtb: 0 },
                React.createElement(SelectWrapper, { id: innerId },
                    !isAsync && this.renderOptions(),
                    isAsync && this.renderAsync())),
            children));
    }
}
//# sourceMappingURL=index.js.map